import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 13 11"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "data-name": "Raggruppa 144" }, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "none",
    d: "M13 11H0V0h13z",
    "data-name": "Rettangolo 128"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#163e4d",
    d: "m1.96 10.047 4.541-6.481 4.541 6.481 1.228-.86L6.501.952.731 9.187Z",
    "data-name": "Tracciato 178"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "arrow-up"}) } }